import { ReactNode } from "react";

import { Box, useTheme } from "@seneca/senekit";

export function PasswordlessSignInWrapper({
  children
}: {
  children: ReactNode;
}) {
  return (
    <div
      style={{
        position: "fixed",
        width: "100vw",
        height: "calc(100% - 70px)",
        top: "70px"
      }}
    >
      {children}
    </div>
  );
}

export function PasswordlessSignInCard({ children }: { children: ReactNode }) {
  const theme = useTheme();

  return (
    <Box
      position="fixed"
      left="50%"
      top="50%"
      transform="translate(-50%, -50%)"
      margin="auto"
      paddingX={["xlarge", "xxlarge"]}
      paddingY="xxlarge"
      maxWidth={["100%", "640px"]}
      maxHeight={["100%", "90%"]}
      width="100%"
      overflowY="auto"
      backgroundColor={theme.foreground}
      height={["100%", "unset"]}
      borderRadius={["none", "12"]}
      display="flex"
      flexDirection="column"
      gap="xxlarge"
    >
      {children}
    </Box>
  );
}
